import types from "../types";

// initial state
const state = {
  ids: [],
  entities: {},
};

// getters
const getters = {
  [types.getters.preArrangements]: (state) =>
    state.ids.map((id) => state.entities[id]),
  [types.getters.preArrangement]: (state) => (preArrangementID) =>
    state.entities[preArrangementID],
  [types.getters.preArrangementByContactID]: (state) => (contactID) => {
    return Object.values(state.entities).filter(
      (preArrangement) => preArrangement.contactID === contactID,
    );
  },
  [types.getters.preArrangementByContactIDAndCategory]:
    (state) => (contactID, category) => {
      return Object.values(state.entities).find(
        (preArrangement) =>
          preArrangement.contactID === contactID &&
          preArrangement.category === category,
      );
    },
};

// actions
const actions = {
  [types.actions.updatePreArrangementField](
    { commit },
    { preArrangementID, fieldName, value },
  ) {
    commit(types.mutations.updatePreArrangementField, {
      preArrangementID,
      fieldName,
      value,
    });
  },
};

// mutations
const mutations = {
  [types.mutations.setPreArrangements](state, preArrangements) {
    state.ids = preArrangements.map(
      (preArrangement) => preArrangement.preArrangementID,
    );
    state.entities = preArrangements.reduce((accumulate, current) => {
      accumulate[current.preArrangementID] = current;
      return accumulate;
    }, {});
  },
  [types.mutations.updatePreArrangementField](
    state,
    { preArrangementID, fieldName, value },
  ) {
    state.entities[preArrangementID][fieldName] = value;
  },
  [types.mutations.copyPreArrangement](
    state,
    { preArrangement, preArrangementToCopyFrom },
  ) {
    state.entities[preArrangement.preArrangementID] = {
      ...preArrangementToCopyFrom,
      preArrangementID: preArrangement.preArrangementID,
      contactID: preArrangement.contactID,
      title: preArrangement.title,
    };
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/preArrangement.js